export const UPDATE_W9_DOCUMENT_REQUEST = 'UPDATE_W9_DOCUMENT_REQUEST';
export const UPDATE_W9_DOCUMENT_SUCCESS = 'UPDATE_W9_DOCUMENT_SUCCESS';
export const UPDATE_W9_DOCUMENT_FAIL = 'UPDATE_W9_DOCUMENT_FAIL';

export const REMOVE_W9_DOCUMENT_REQUEST = 'REMOVE_W9_DOCUMENT_REQUEST';
export const REMOVE_W9_DOCUMENT_SUCCESS = 'REMOVE_W9_DOCUMENT_SUCCESS';
export const REMOVE_W9_DOCUMENT_FAIL = 'REMOVE_W9_DOCUMENT_FAIL';
